
<div>
  <mat-card>
    
      <mat-card-header>
        <mat-card-title i18n="section header">Profile</mat-card-title>
      </mat-card-header>
      
      <mat-card-content>
        <profile-editor></profile-editor>
      </mat-card-content>
    
      <mat-card-actions>
        <button mat-raised-button type="submit" 
            (click)="update()" 
            color="accent" 
            [disabled]="!editor || !editor.isValid" 
            i18n="update profile button label">Update</button>
      </mat-card-actions>
      
  </mat-card>
</div>